module.exports = __webpack_public_path__ + "img/share.2fa524ad.jpg";